var map = {
	"./SpinT1_001.webp": 57851,
	"./SpinT1_002.webp": 55937,
	"./SpinT1_003.webp": 26744,
	"./SpinT1_004.webp": 86443,
	"./SpinT1_005.webp": 8382,
	"./SpinT1_006.webp": 23972,
	"./SpinT1_007.webp": 11945,
	"./SpinT1_008.webp": 24974,
	"./SpinT1_009.webp": 76997,
	"./SpinT1_010.webp": 13724,
	"./SpinT1_011.webp": 44145,
	"./SpinT1_012.webp": 27211,
	"./SpinT1_013.webp": 30381,
	"./SpinT1_014.webp": 71525,
	"./SpinT1_015.webp": 24109,
	"./SpinT1_016.webp": 54085,
	"./SpinT1_017.webp": 72357,
	"./SpinT1_018.webp": 92741,
	"./SpinT1_019.webp": 43212,
	"./SpinT1_020.webp": 16435,
	"./SpinT1_021.webp": 6110,
	"./SpinT1_022.webp": 49202,
	"./SpinT1_023.webp": 67077,
	"./SpinT1_024.webp": 552,
	"./SpinT1_025.webp": 48176,
	"./SpinT1_026.webp": 41171,
	"./SpinT1_027.webp": 2679,
	"./SpinT1_028.webp": 14056,
	"./SpinT1_029.webp": 61737,
	"./SpinT1_030.webp": 21685,
	"./SpinT1_031.webp": 26350,
	"./SpinT1_032.webp": 67163,
	"./SpinT1_033.webp": 15998,
	"./SpinT1_034.webp": 92662,
	"./SpinT1_035.webp": 30820,
	"./SpinT1_036.webp": 88116,
	"./SpinT1_037.webp": 56199,
	"./SpinT1_038.webp": 76236,
	"./SpinT1_039.webp": 41250,
	"./SpinT1_040.webp": 69880,
	"./SpinT1_041.webp": 21354,
	"./SpinT1_042.webp": 42022,
	"./SpinT1_043.webp": 59770,
	"./SpinT1_044.webp": 63064,
	"./SpinT1_045.webp": 36823,
	"./SpinT1_046.webp": 57222,
	"./SpinT1_047.webp": 77711,
	"./SpinT1_048.webp": 88497,
	"./SpinT1_049.webp": 52029,
	"./SpinT1_050.webp": 77793,
	"./SpinT1_051.webp": 52333,
	"./SpinT1_052.webp": 73665,
	"./SpinT1_053.webp": 43595,
	"./SpinT1_054.webp": 13530,
	"./SpinT1_055.webp": 54822,
	"./SpinT1_056.webp": 13231,
	"./SpinT1_057.webp": 16192,
	"./SpinT1_058.webp": 70459,
	"./SpinT1_059.webp": 92574,
	"./SpinT1_060.webp": 80527,
	"./SpinT1_061.webp": 65747,
	"./SpinT1_062.webp": 66147,
	"./SpinT1_063.webp": 92099,
	"./SpinT1_064.webp": 30586,
	"./SpinT1_065.webp": 14498,
	"./SpinT1_066.webp": 67579,
	"./SpinT1_067.webp": 44007,
	"./SpinT1_068.webp": 53327,
	"./SpinT1_069.webp": 83391,
	"./SpinT1_070.webp": 96906,
	"./SpinT1_071.webp": 74160,
	"./SpinT1_072.webp": 67540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68748;